import { CreditCard } from '@alinta-digital/payment-form/components';
import { PaymentCardType } from '@alinta-digital/payment-form/types';
import { CustomCheckout } from '@alinta-digital/payment-form/view/PaymentDetails/PaymentDetails';
import { useFormikContext } from 'formik';
import React from 'react';

interface DirectDebitCreditCardProps {
  instance: CustomCheckout | null;
  loading: boolean;
  setIsCardValid: (isValid: boolean) => void;
}

const DirectDebitCreditCard = ({
  instance,
  loading,
  setIsCardValid,
}: DirectDebitCreditCardProps) => {
  const { setFieldValue } = useFormikContext();
  return (
    <CreditCard
      sectionKey="debitDetails"
      instance={instance}
      onError={() => {
        setFieldValue('debitDetails.cardType', '', false);
        setIsCardValid(false);
      }}
      onComplete={(cardType: PaymentCardType) => {
        setFieldValue('debitDetails.cardType', cardType, false);
        setIsCardValid(true);
      }}
      disabled={loading}
    />
  );
};

export default DirectDebitCreditCard;
